<template>
  <div :style="`width:100%;height:${dispH}px;border-top:1px solid gray;`">
    <canvas id="thickCanvas" width="920px" :height="`${dispH - 10}px`" />
  </div>
</template>

<script>
import { draw } from "../js/ThickDrawn";
let element;
let ctx;
export default {
  name: "RGP-Thick",
  components: {},
  props: {
    dispH: {
      required: true,
      type: Number
    },
    dataX: {
      required: true,
      type: Array
    },
    dataY: {
      required: true,
      type: Array
    },
    rotateAngle: {
      default: 0
    }
  },
  methods: {
    drawCurve() {
      const flag = this.rotateAngle < 90 || this.rotateAngle > 270;
      draw(element, ctx, this.dataX, this.dataY, this.rotateAngle, flag);
    },
    initData() {
      element = document.getElementById("thickCanvas");
      ctx = element.getContext("2d");
      this.drawCurve();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initData();
    });
  },
  watch: {
    dataY: {
      handler: function () {
        this.initData();
      },
      deep: true
    }
    // dataY: {
    //   handler: function () {
    //     console.log('dataY changed', this.dataY)
    //     this.initData()
    //   },
    //   deep: true
    // }
  }
};
</script>

<style lang="less" scoped>
.image {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/RGP-Thick.vue